import { useLang } from "@/context/LangContext";

export default function ArtworkImage({ art, className = "", annotate = true }) {
  const { t } = useLang();
  return (
    <div className={className}>
      <div className="overflow-hidden border border-bone/10 bg-ink-2">
        {art.image_url ? (
          <img
            data-testid={`artwork-image-${art.artwork_id}`}
            src={art.image_url}
            alt={art.title}
            loading="lazy"
            className="block h-auto w-full"
          />
        ) : (
          <div className="flex aspect-[5/4] w-full flex-col items-center justify-center gap-3 bp-grid-fine">
            <span className="tick" style={{ position: "relative" }} />
            <span className="font-mono text-[10px] tracking-[0.3em] text-bone-muted">
              {t("product.noPhoto")}
            </span>
          </div>
        )}
      </div>
      {annotate && (
        <div data-testid={`artwork-specs-${art.artwork_id}`} className="mt-2 flex flex-col gap-0.5 border-l border-brass/40 pl-3 font-mono text-[8px] tracking-[0.18em]">
          <span className="text-brass">{art.dwg_no || "DEMOIVRE"}</span>
          <span className="text-bone-dim">{t("product.dimensions")} — {art.dimensions}</span>
          <span className="text-bone-muted">{t("product.format")} — {t("product.formatValue").toUpperCase()}</span>
          <span className="text-bone-muted">{t("product.framing")} — {t("product.framingValue").toUpperCase()}</span>
          <span className="text-bone-muted">{t("product.edition")} — {t("product.editionValue").toUpperCase()}</span>
        </div>
      )}
    </div>
  );
}
